import { components } from 'react-select'
import { User } from '@features/file-explorer/types'
import UserAvatar from '@components/UserAvatar'

// Format user display name
export const formatUserName = (user: User): string => {
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`
  }
  return user.email
}

// Custom option component for React-Select with UserAvatar
export const CustomOption = (props: any) => {
  const { data, innerRef, innerProps } = props
  const user = data.user

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex items-center gap-3 px-4 py-2 cursor-pointer hover:bg-base-200"
    >
      <UserAvatar user={user} size="sm" showTooltip={false} />
      <div className="flex-1 min-w-0">
        <div className="font-medium text-base-content">{data.label}</div>
        <div className="text-sm text-base-content/70 truncate">{user.email}</div>
      </div>
    </div>
  )
}

// Custom single value component for React-Select with UserAvatar
export const CustomSingleValue = (props: any) => {
  const { data } = props
  const user = data.user

  return (
    <components.SingleValue {...props}>
      <div className="flex items-center gap-2">
        <UserAvatar user={user} size="xs" showTooltip={false} />
        <span>{data.label}</span>
      </div>
    </components.SingleValue>
  )
}

// Custom styles for React-Select to match DaisyUI
export const customSelectStyles = {
  control: (base: any, _state: any) => ({
    ...base,
    borderColor: base.borderColor,
    boxShadow: 'none',
    '&:hover': {
      borderColor: base.borderColor
    }
  }),
  menuPortal: (base: any) => ({
    ...base,
    zIndex: 999999
  }),
  menuList: (base: any) => ({
    ...base,
    padding: 0,
    backgroundColor: 'oklch(var(--b1))'
  }),
  option: (base: any) => ({
    ...base,
    backgroundColor: 'transparent',
    padding: 0
  }),
  input: (base: any) => ({
    ...base,
    color: 'oklch(var(--bc))',
    'input:focus': {
      outline: 'none',
      boxShadow: 'none',
      border: 'none'
    }
  }),
  placeholder: (base: any) => ({
    ...base,
    color: 'oklch(var(--bc) / 0.5)'
  }),
  noOptionsMessage: (base: any) => ({
    ...base,
    color: 'oklch(var(--bc) / 0.7)',
    padding: '0.75rem 1rem',
    backgroundColor: 'oklch(var(--b1))'
  }),
  loadingMessage: (base: any) => ({
    ...base,
    color: 'oklch(var(--bc) / 0.7)',
    padding: '0.75rem 1rem',
    backgroundColor: 'oklch(var(--b1))'
  })
}
